export const environment = {
    production: true,
    env: 'production',
    apiUrl: 'https://api.csp.cdrc.app',
    whitelistedDomains: ['api.csp.cdrc.app'],
    blacklistedRoutes: [],
    imgixDomain: 'https://csp-cdrc-backend-production-backend.s3.ap-southeast-2.amazonaws.com',
    vapidPubKey: 'BMxnj8mJKGxvYktBKR7C-NWLZBpMtC59-50gGj6AhC0RbFmF8ArKnQvGYtJEqRfUvQ_BLcSqFD5enNdoMmARJ7o',
    gaMeasurementId: 'G-QW3DHSW4F0',
};
